import { type InjectionKey } from 'vue'
import { type LazyBlockToolsInject } from './types'

export const lazyBlockToolsInjectionKey = Symbol('lazyBlockTools') as InjectionKey<LazyBlockToolsInject>
export const repeatableContainerIdKey = Symbol('repeatableContainerId') as InjectionKey<string>